(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('filesLast', FilesLast)

    /** @ngInject */
    function FilesLast($window, $timeout, $rootScope, HelperService, AuthenticationService, FileService, ROUTES, PATHS, LOCAL_STORAGE_ITEMS, DATA_EVENTS) {
        function FilesLastController($scope) {
            const vm = this;

            let userData;

            vm.formatSize = FileService.formatSize;

            vm.downloadFile = file => {
                let accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);

                return FileService
                    .verifyDownload(file.Id)
                    .then(() => $window.location.href = `${ROUTES.API}/files/download/${userData.Id}/${file.Id}?accessToken=${accessToken}`, error => HelperService.errorCallback(error));
            }

            vm.getFileIcon = file => {
                return HelperService.imageHandlerFileIcon(file.Extension.trim());
            }

            vm.showFileModal = file => {
                vm.selectedFile = file;

                $timeout(() => {
                    $('#modalDetailsFile').modal('show');
                });
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            function getFiles() {
                HelperService.startLoading('.last-elements.files');

                vm.isLoading = true;

                FileService
                    .getAllByParameters({
                        PerPage: 4,
                        Skip: 0,
                        ResponsibilityId: userData.Responsibility.Id,
                        OrderBy: 'RegistrationDate',
                        OrderDescending: true
                    })
                    .then(success => {
                        vm.isLoading = false;
                        vm.files = success.Files;
                        HelperService.stopLoading('.last-elements.files');
                    }, error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.last-elements.files');
                    })
            }

            function init() {
                vm.isLoading = true;
                vm.files = [];

                userData = AuthenticationService.getUserData();;

                getFiles();
            }
        }

        return {
            bindToController: true,
            controller: FilesLastController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/files-last/files-last.html`,
            scope: {}
        }
    }
}());